import { render } from "./AutoCreateGroups.vue?vue&type=template&id=3a5e9fb2"
import script from "./AutoCreateGroups.vue?vue&type=script&lang=js"
export * from "./AutoCreateGroups.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__